import { Stack, Text, useTheme } from '@fluentui/react';

export const Header: React.FC = () => {
  const theme = useTheme();
  return (
    <Stack
      horizontal
      style={{
        borderBottom: `1px solid ${theme.palette.neutralLight}`,
        paddingBottom: 16,
        marginRight: 4,
      }}
    >
      <Stack grow>
        <Text variant="large" style={{ fontWeight: 600 }}>
          Rules
        </Text>
      </Stack>
      <Text variant="large" style={{ fontWeight: 600, marginRight: 350 }}>
        Settings
      </Text>
    </Stack>
  );
};
